module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.infiniteScrollCallback),
      expression: "infiniteScrollCallback"
    }],
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal,
      "infinite-scroll-disabled": "infiniteScrollDisabled",
      "infinite-scroll-distance": "20",
      "infinite-scroll-immediate-check": "true"
    }
  }, [_c('el-row', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-TimelineModel-Header"
    },
    slot: "header"
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "data-qa": "Dialog-TimelineModel-Title"
    }
  }, [_vm._v(_vm._s(_vm.$t('timelineComponentTitle')))]), _vm._v(" "), (_vm.showEventFilter) ? _c('el-col', {
    staticClass: "type-filter",
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "label": _vm.$t('timelineFilterPlaceholder'),
      "data-qa": "Dialog-TimelineModel-Filter-Select"
    },
    on: {
      "change": _vm.changeFilterType
    },
    model: {
      value: (_vm.filterType),
      callback: function($$v) {
        _vm.filterType = $$v
      },
      expression: "filterType"
    }
  }, _vm._l((_vm.headerSelectFilter), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "data-qa": item.dataQA,
        "label": _vm.$t(item.text),
        "value": item.value
      }
    })
  }))], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "data-qa": "Dialog-TimelineModel-Body"
    }
  }, [_c('timeline-log', {
    attrs: {
      "log-list": _vm.lists,
      "fields": _vm.fields
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37f2c0c8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimelineModel/TimelineModel.vue
// module id = 963
// module chunks = 3